module.exports = __webpack_public_path__ + "img/grey.07beca96.webp";